/// <amd-module name="Wit/Common/WitSettingsViews/Utils/FieldUtils" />
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { IListBoxItem } from "VSSUI/ListBox";
import * as WebApiContracts from "Wit/Clients/Work/Contracts/Work";
import * as DataProviderContracts from "Wit/Common/Generated/Constants";
import { FieldType, FieldUsages } from "Wit/Common/Generated/Constants";
import { IFieldEntry } from "Wit/Common/Generated/Contracts";

/**
 * Filter all the field definitions to the set of supported ones.
 * Filters based on supported field types, black listed fields, and whether the field definition is an extension.
 */
export function getSupportedFieldDefinitions(
    allFields: IFieldEntry[],
    supportedFieldTypes: Set<FieldType>,
    notSupportedFieldReferenceNames: Set<string>,
    includeIgnored?: boolean
): IFieldEntry[] {
    let supportedFields: IFieldEntry[] = allFields.filter(
        field =>
            supportedFieldTypes.has(field.type) &&
            !notSupportedFieldReferenceNames.has(field.referenceName.toLowerCase()) &&
            !field.isHtml &&
            field.isQueryable &&
            field.usages !== FieldUsages.WorkItemTypeExtension
    );

    if (!includeIgnored) {
        supportedFields = supportedFields.filter(field => !field.isIgnored);
    }

    return supportedFields.sort((a, b) => localeIgnoreCaseComparer(a.name, b.name));
}

export function toWebApiFieldType(fieldType: DataProviderContracts.FieldType): WebApiContracts.FieldType {
    switch (fieldType) {
        case DataProviderContracts.FieldType.Boolean:
            return WebApiContracts.FieldType.Boolean;
        case DataProviderContracts.FieldType.DateTime:
            return WebApiContracts.FieldType.DateTime;
        case DataProviderContracts.FieldType.Double:
            return WebApiContracts.FieldType.Double;
        case DataProviderContracts.FieldType.Integer:
            return WebApiContracts.FieldType.Integer;
        case DataProviderContracts.FieldType.PlainText:
            return WebApiContracts.FieldType.PlainText;
        case DataProviderContracts.FieldType.String:
            return WebApiContracts.FieldType.String;
        case DataProviderContracts.FieldType.TreePath:
            return WebApiContracts.FieldType.TreePath;
        default:
            return WebApiContracts.FieldType.String;
    }
}

export function getListBoxItemsFromFields(fieldEntries: IFieldEntry[]): IListBoxItem[] {
    return fieldEntries.map(field => {
        return { id: field.referenceName, text: field.name } as IListBoxItem;
    });
}
